import React, { useState, useEffect } from 'react';
import { Table, Tooltip } from "antd";
import useAuth from '../hooks/useAuth.js';
import commonfunction from '../utilities/commonFunction.js';
import SearchBar from './SearchBar.js';
import 'antd/dist/antd.min.css';
import { ModelReport } from '../utilities/Model';
import axiosInstance from '../utilities/axiosInstance';
import axios from 'axios';

function Reports() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [taskMediaType, setTaskMediaType] = useState();
  const [open, setOpen] = useState(false);
  const [taskid, setTaskId] = useState();
  const [searchValue, setSearchValue] = useState('');
  const [finalData, setFinalData] = useState([]);
  const { auth } = useAuth();

  useEffect(() => {
    axiosInstance.get(`/v2/report-result`, {
      params: {
        profileId: auth.profile_id,
        roleId: auth.profile_role
      }
    })
      .then(res => {
        setData(res.data);
        setTaskMediaType(res.data);
        setFinalData(res.data);
        setLoading(false);
      }).catch(error => {
        console.log(error)
      });
  }, []);

  useEffect(() => {
    if (searchValue != '') {
      const newData = data.filter((item) => {
        return item.tagger.includes(searchValue);
      })
      setFinalData(newData);
    } else {
      setFinalData(data);
    }
  }, [searchValue])

  const downloadPolygonFile = async (format, reportId, projectId, projectName, taskMediaType) => {
    console.warn("downloadPolygonFile", "format:", format, "reportId:", reportId, ",projectId:", projectId, ",projectName:", projectName, ",task_mediatype:", taskMediaType);
    if (format === "json") {
      try {
        const response = await axiosInstance.get(`/v2/report/polygon/${taskMediaType}/${format}/${projectId}`, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${reportId}${projectId}${projectName}-polygon-${format}-${taskMediaType}.${format}`); // Adjust filename as needed
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error downloading file:', error);
      }

    }

    if (format === "xml") {
      try {
        const response = await axiosInstance.get(`/v2/report/polygon/${taskMediaType}/${format}/${projectId}`, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${reportId}${projectId}${projectName}-polygon-${format}-${taskMediaType}.${format}`); // Adjust filename as needed
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error downloading file:', error);
      }

    }
    if (format === "coco") {
      try {
        const response = await axiosInstance.get(`/v2/report/polygon/${taskMediaType}/${format}/${projectId}`, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${reportId}${projectId}${projectName}-polygon-${format}-${taskMediaType}.json`); // Adjust filename as needed
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error downloading file:', error);
      }

    }
  }
  const downloadRectangleBBFile = async (format, reportId, projectId, projectName, taskMediaType) => {
    console.warn("downloadRectangleBBFile", "format:", format, "reportId:", reportId, ",projectId:", projectId, ",projectName:", projectName, ",task_mediatype:", taskMediaType);

    if (format === "json") {
      try {
        const response = await axiosInstance.get(`/report/rectangleBB/${taskMediaType}/${format}/${projectId}`, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${reportId}${projectId}${projectName}-rectangle-${format}-${taskMediaType}.${format}`); // Adjust filename as needed
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error downloading file:', error);
      }
    }

    if (format === "xml") {
      try {
        const response = await axiosInstance.get(`/report/rectangleBB/${taskMediaType}/${format}/${projectId}`, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${reportId}${projectId}${projectName}-rectangle-${format}-${taskMediaType}.${format}`); // Adjust filename as needed
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error downloading file:', error);
      }

    }

    if (format === "yolo") {
      // try {
      //   const response = await axiosInstance.get(`/report/rectangleBB/${taskMediaType}/${format}/${taskId}`, {
      //     responseType: 'blob'
      //   });

      //   const url = window.URL.createObjectURL(new Blob([response.data]));
      //   const link = document.createElement('a');
      //   link.href = url;
      //   link.setAttribute('download', `${reportId}${taskId}${projectName}-rectangle-${format}-${taskMediaType}.txt`); // Adjust filename as needed
      //   document.body.appendChild(link);
      //   link.click();
      //   link.remove();
      // } catch (error) {
      //   console.error('Error downloading file:', error);
      // }

      try {
        const response = await axiosInstance.get(
          `/v2/report/rectangleBB/${taskMediaType}/${format}/${projectId}`,
          {
            responseType: 'blob',
          }
        );

        // Create a URL for the blob data
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // Create a temporary link element
        const link = document.createElement('a');
        link.href = url;

        // Set the download attribute with the desired filename
        link.setAttribute(
          'download',
          `${reportId}${projectId}${projectName}-rectangle-${format}-${taskMediaType}.zip` // Changed extension to .zip
        );

        // Programmatically click the link to trigger the download
        document.body.appendChild(link);
        link.click();

        // Clean up the URL object
        window.URL.revokeObjectURL(url);

        // Remove the temporary link
        link.remove();

      } catch (error) {
        console.error('Error downloading file:', error);
      }
    }
  }

  const downloadDocReport = async (format, reportId, taskId, projectName, taskMediaType) => {
    console.warn("downloadRectangleBBFile", "format:", format, "reportId:", reportId, ",taskId:", taskId, ",projectName:", projectName, ",task_mediatype:", taskMediaType);
      try {
        const response = await axiosInstance.get(`/report/rectangleBB/${taskMediaType}/${format}/${taskId}`, {
          responseType: 'blob'
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `${reportId}${taskId}${projectName}-rectangle-${format}-${taskMediaType}.${format}`); // Adjust filename as needed
        document.body.appendChild(link);
        link.click();
        link.remove();
      } catch (error) {
        console.error('Error downloading file:', error);
      }
  }

  const downloadMaskedFile = async (format, reportId, taskId, projectName, taskMediaType) => {
    try {
      const response = await axiosInstance.post(`/report/mask`, {
        reportId: reportId,
        taskId: taskId,
        projectName: projectName,
        taskMediaType: taskMediaType
      });
      if (response.data?.length > 0) {
        const transformPayload = (rawInput) => {
          return rawInput.map((file) => {
            const newRectangles = {};

            for (const [pageNum, rectList] of Object.entries(file.rectangles)) {
              newRectangles[pageNum] = rectList.map((r) => ({
                x: r.geometry_x,
                y: r.geometry_y,
                width: r.geometry_width,
                height: r.geometry_height,
                fillColor: "#696969" ,// default fill color; you can customize this
                // maskWith: maskWith
              }));
            }

            return {
              pdfUrl: file.pdfUrl,
              rectangles: newRectangles
            };
          });
        };
        let rawPayload = response.data
        const transformedPayload = { files: transformPayload(rawPayload) };
        const res = await axios.post('https://uat-tagging.enfusesolutions.com/api/pdf/generate-masked-zip', transformedPayload, {
          headers: { "Content-Type": "application/json" },
          responseType: "blob"
        });

        const blob = new Blob([res.data], { type: 'application/zip' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'masked_pdfs.zip');
        document.body.appendChild(link);
        link.click();
        link.remove();
      }
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  }

  const handleChange = (e) => {
    console.warn(e.target.value);
    const [datasets, format, reportId, projectId, projectName, taskMediaType] = e.target.value.split(',');
    console.warn(datasets, format, reportId, projectId, projectName, taskMediaType);
    if (datasets === "rect") {
      downloadRectangleBBFile(format, reportId, projectId, projectName, taskMediaType)
    }
    if (datasets === "poly") {
      downloadPolygonFile(format, reportId, projectId, projectName, taskMediaType)
    }
    if(datasets === "rect_mask"){
      downloadMaskedFile(format, reportId, projectId, projectName, taskMediaType)
    }
     if(datasets === "rect_doc"){
      downloadDocReport(format, reportId, projectId, projectName, taskMediaType)
    }
  }

  const columns = [
    {
      title: (
        <Tooltip title="Created Date">
          <span>Date</span>
        </Tooltip>
      ),
      dataIndex: 'createdDate',
      key: 'createdDate',
      render: (date) => new Date(date).toLocaleDateString()
    },
    // {
    //   title: (
    //     <Tooltip title="Forlder Title">
    //       <span>Title</span>
    //     </Tooltip>
    //   ),
    //   dataIndex: 'task_folder_name',
    //   key: 'task_folder_name',
    //   render: (text) => (
    //           <Tooltip title={text}>
    //             <div style={{
    //               width: '110px',
    //               whiteSpace: 'nowrap',
    //               overflow: 'hidden',
    //               textOverflow: 'ellipsis'
    //             }}>
    //               {text}
    //             </div>
    //           </Tooltip>
    //           )
    // },
    {
      title: (
        <Tooltip title="Task status">
          <span>Status</span>
        </Tooltip>
      ),
      dataIndex: 'task_status',
      key: 'task_status',
    },
    {
      title: (
        <Tooltip title="Project Name">
          <span>Project</span>
        </Tooltip>
      ),
      dataIndex: 'project_name',
      key: 'project_name',
      render: (text) => (
              <Tooltip title={text}>
                <div style={{
                  width: '110px',
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis'
                }}>
                  {text}
                </div>
              </Tooltip>
              )
    },
    // {
    //   title: (
    //     <Tooltip title="Tagger User ID">
    //       <span>Tagger</span>
    //     </Tooltip>
    //   ),
    //   dataIndex: 'tagger',
    //   key: 'profile_id',
    //   render: (text) => (
    //           <Tooltip title={text}>
    //             <div style={{
    //               width: '100px',
    //               whiteSpace: 'nowrap',
    //               overflow: 'hidden',
    //               textOverflow: 'ellipsis'
    //             }}>
    //               {text}
    //             </div>
    //           </Tooltip>
    //           )
    // },
    // {
    //   title: (
    //     <Tooltip title="Reviewer User ID">
    //       <span>Reviewer</span>
    //     </Tooltip>
    //   ),
    //   dataIndex: 'reviewer',
    //   key: 'reviewer_profile_id',
    //   render: (text) => (
    //           <Tooltip title={text}>
    //             <div style={{
    //               width: '100px',
    //               whiteSpace: 'nowrap',
    //               overflow: 'hidden',
    //               textOverflow: 'ellipsis'
    //             }}>
    //               {text}
    //             </div>
    //           </Tooltip>
    //           )
    // },
    {
      title: (
        <Tooltip title="Media Type">
          <span>Media</span>
        </Tooltip>
      ),
      dataIndex: 'task_mediatype',
      key: 'task_mediatype',
    },
    {
      title: (
        <Tooltip title="Process Type">
          <span>Process</span>
        </Tooltip>
      ),
      dataIndex: 'task_process_type',
      key: 'task_process_type',
    },
    {
      title: (
        <Tooltip title="Delay for task">
          <span>Delay</span>
        </Tooltip>
      ),
      dataIndex: '',
      key: 'delay',
      render: (text, records) => {
        return (
          <div width="120">{commonfunction.getDelay(records.task_completedDate)}</div>
        )
      }
    },
    {
      title: (
        <Tooltip title="Attached">
          <span>Attached</span>
        </Tooltip>
      ),
      dataIndex: 'attached',
      key: 'attached',
      render: (text, records) => {
        let jsonFileUrl = process.env.PUBLIC_URL + `/Reports/Report${records.report_id}${records.task_id}${records.project_name}.json`;
        return (
          <div>
            {/* <span><a href={`${jsonFileUrl}`} download={`Report${records.report_id}${records.task_id}${records.project_name}.json`}>Co-ordinate Report BB(JSON)</a></span><br />
            <span><a href="#" onClick={() => downloadRectangleBBFile("xml", records.report_id, records.task_id, records.project_name, records.task_mediatype)}>
              Co-ordinate Report BB(XML)
            </a></span><br /> */}
            {/* <span><a href={"#"}>Co-ordinate Report (Yullo)</a></span> <br />*/}
            {/* <span><a href="#" onClick={() => downloadPolygonFile("json", records.report_id, records.task_id, records.project_name, records.task_mediatype)}>
            Co-ordinate Report Polygon (JSON)
            </a></span><br /> */}

            {/* <span><a href="#" onClick={() => downloadPolygonFile("xml", records.report_id, records.task_id, records.project_name, records.task_mediatype)}>
            Co-ordinate Report Polygon (XML)
            </a></span> */}
            <select onChange={handleChange}>
              <option>Select Option</option>
              {records.task_mediatype == 'image' && <option value={`rect,json,${records.report_id},${records.project_id},${records.project_name},${records.task_mediatype}`}>
                Co-ordinate Report BB(JSON)
              </option>}
              {records.task_mediatype == 'image' && <option value={`rect,xml,${records.report_id},${records.project_id},${records.project_name},${records.task_mediatype}`}>
                Co-ordinate Report BB(XML)
              </option>}
              {records.task_mediatype == 'image' && <option value={`rect,yolo,${records.report_id},${records.project_id},${records.project_name},${records.task_mediatype}`}>
                Co-ordinate Report YOLO (TXT)
              </option>}
              {records.task_mediatype == 'image' && <option value={`poly,coco,${records.report_id},${records.project_id},${records.project_name},${records.task_mediatype}`}>
                Co-ordinate Report COCO (JSON)
              </option>}
              {
                records.task_mediatype == 'doc' && <option value={`rect_doc,ndjson,${records.report_id},${records.task_id},${records.project_name},${records.task_mediatype}`}>
                  Co-ordinate Report (NDJSON)
                </option>
              }
              {
                records.task_mediatype == 'doc' && records?.project_type == "Masking / Ignore Zones" && <option value={`rect_mask,mask,${records.report_id},${records.task_id},${records.project_name},${records.task_mediatype}`}>
                  Download File (MASK)
                </option>
              }
            </select>
          </div>
        )
      }
    },
    {
      title: (
        <Tooltip title="Replaced Doc container">
          <span>Container</span>
        </Tooltip>
      ),
      dataIndex: '',
      key: 'docvalue',
      render: (text, records) => {
        return ((records.task_mediatype === 'doc') ? <div><img src={`${process.env.PUBLIC_URL}/icon/folder-docs.jpg`} style={{ width: 35 }} onClick={handleDocOPen} /></div> : '-');
      }
    }
  ];

  const handleDocOPen = (e) => {
    const { id } = e.target;
    console.log(e);
    setOpen(true);
    setTaskId(id);
  }
  const handleClose = () => setOpen(false);
  return (
    <div>
      <h2 className="font-poppins font-medium text-[20px] leading-[100%] tracking-[0%] text-gray-main pb-3 border-b border-gray-d-200 dark:text-white dark:border-white mb-[20px]">Welcome {(auth.profile_name !== 'null') ? auth.profile_name : auth.profile_username} - Reports Page</h2>
      <div>
        <div style={{ height: '400px' }}>
          {/* <ProfileData /> */}
          <Table className="details-view-table" columns={columns} dataSource={finalData} loading={loading} pagination={{ pageSize: 6 }} rowKey="task_id" />
        </div>
        <ModelReport open={open} handleClose={handleClose} taskId={taskid} />
      </div>
    </div>

  )
}

export default Reports